<!-- 首页 -->
<template>
  <div :class="['recentMoreLiveCourse', { inApp: $root.$data.isApp }]">
    <common-title titleName="直播公开课" :bcColor="'#fff'" :zIndex="1000"></common-title>
    <recentLiveCourse
      :numLength="false"
      :isShow="false"
      :classCode='classCode'
      ref="liveCours"
      @openLive="openLive"
      @showRemindBox="showRemindBox"
    ></recentLiveCourse>
    <!-- 开播提醒弹框 -->
    <RemindBox v-if="isRemindBox" @closeRemindBox="closeRemindBox" />
    <!-- 直播弹出 -->
    <MultipleLiveCourse
      :videoList="videoList"
      :openCourseId="openCourseId"
      v-if="showLive"
      @closeLive="closeLive"
    />
  </div>
</template>
<script>
// import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import recentLiveCourse from './components/recentLiveCourse.vue';
import RemindBox from '@/components/remindBox/index.vue';
import MultipleLiveCourse from '../../components/multipleLiveCourse/index.vue';

export default {
  data() {
    return {
      isRemindBox: false, // 开播提醒弹框
      videoList: [],
      openCourseId: '',
      showLive: false,
      classCode: Number(this.$route.query.classCode),
    };
  },
  components: {
    CommonTitle,
    recentLiveCourse,
    RemindBox,
    MultipleLiveCourse,
  },
  computed: {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },

  methods: {
    async getLoginAfter() {
      await this.$root.getUserInfo();
      await this.$refs.liveCours.getOpenCourse();
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    closeLive() {
      this.showLive = false;
    },
    openLive(data) {
      this.videoList = data.videoList;
      this.openCourseId = data.openCourseRecordId;
      this.showLive = true;
    },
  },
  beforeDestroy() {
    clearTimeout();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot {
  position: fixed;
}
.recentMoreLiveCourse {
  width: 100%;
  height: 100vh;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #fff;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
